import constants from "../utils/constants";
import { privateRequest } from "../utils/axsiosInstances";

class UserController {
  static unlock(data) {
    return privateRequest({
      method: "post",
      url: constants.authentication.userV1 + "unlock",
      data: {
        mobile: data.mobile,
        password: data.password,
        deviceId:
          "eyJzeXN0ZW1fbmFtZSI6IkFuZHJvaWQiLCJzeXN0ZW1fdmVyc2lvbiI6IjExIiwibW9kZWwiOiJBbmRyb2lkIFNESyBidWlsdCBmb3IgeDg2IiwibWFudWZhY3R1cmVyIjoidW5rbm93biIsImRldmljZSI6ImdlbmVyaWNfeDg2IiwiYW5kcm9pZF9pZCI6ImY1Y2NkMzBmYTk4YWY2MzYifQ==",
      },
    });
  }

  static logout() {
    const refreshToken = localStorage.getItem("refreshToken");
    return privateRequest({
      method: "post",
      url: constants.authentication.userV1 + "logout",
      data: {
        refreshToken: refreshToken,
      },
    });
  }

  static changePassword(data) {
    return privateRequest({
      method: "post",
      url: constants.authentication.userV1 + "change-password",
      data: {
        currentPassword: data.currentPassword,
        newPassword: data.newPassword,
      },
    });
  }

  static sendChangeMobileOTP(data) {
    return privateRequest({
      method: "post",
      url: constants.authentication.userV1 + "change-mobile",
      params: {
        mobile: data.mobile,
      },
    });
  }

  static confirmChangeMobile(data) {
    return privateRequest({
      method: "post",
      url: constants.authentication.userV1 + "change-mobile/otp",
      data: {
        newMobile: data.newMobile,
        currentMobile: data.currentMobile,
        otp: data.otp,
      },
    });
  }
}

export default UserController;
